import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { AuthProvider, useAuth } from './context/AuthContext';

import Login from './pages/Login';
import Signup from './pages/Signup';
import Dashboard from './pages/Dashboard';
import Leads from './pages/Leads';
import LeadDetail from './pages/LeadDetail';
import Customers from './pages/Customers';
import CustomerDetail from './pages/CustomerDetail';
import Integrations from './pages/Integrations';
import AdminPanel from './pages/AdminPanel';
import Layout from './components/Layout';

var ProtectedRoute = function (props) {
    var { isAuthenticated, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-10 w-10 border-b-2" style={{ borderColor: '#25D366' }}></div></div>;
    if (!isAuthenticated) return <Navigate to="/login" replace />;
    return <Layout>{props.children}</Layout>;
};

var PublicRoute = function (props) {
    var { isAuthenticated, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center"><div className="animate-spin rounded-full h-10 w-10 border-b-2" style={{ borderColor: '#25D366' }}></div></div>;
    if (isAuthenticated) return <Navigate to="/dashboard" replace />;
    return props.children;
};

var AppRoutes = function () {
    return (
        <Routes>
            <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/leads" element={<ProtectedRoute><Leads /></ProtectedRoute>} />
            <Route path="/leads/:id" element={<ProtectedRoute><LeadDetail /></ProtectedRoute>} />
            <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
            <Route path="/customers/:id" element={<ProtectedRoute><CustomerDetail /></ProtectedRoute>} />
            <Route path="/integrations" element={<ProtectedRoute><Integrations /></ProtectedRoute>} />
            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
    );
};

var App = function () {
    return (
        <Router>
            <AuthProvider>
                <Toaster position="top-right" toastOptions={{ duration: 3000, style: { background: '#fff', color: '#1f2937', boxShadow: '0 10px 15px -3px rgba(0,0,0,0.1)', borderRadius: '12px', padding: '12px 16px', fontSize: '14px' } }} />
                <AppRoutes />
            </AuthProvider>
        </Router>
    );
};

export default App;